import { useModal } from '@/features/Modal/Modal.hooks'
import { Modal } from 'antd'
import React, { useCallback } from 'react'
import classnames from 'classnames'
import styles from '../TermsModal/TermsModal.module.scss'

export function PrivacyPolicyModal() {
  const { destroyModal } = useModal()

  const onClose = useCallback(() => {
    destroyModal()
  }, [destroyModal])

  return (
    <Modal className={classnames('fullScreenModal', styles.root)} title={null} onCancel={onClose} footer={null} centered open closable>
      <iframe
        title="terms-modal"
        className={styles.frame}
        src="https://godeficapital.com/privacy-policy.html"
      />
    </Modal>
  )
}
